import axios from "axios";

const normalize = (url: string) => url.replace(/\/+$/, "");
const CLOUD_BASE_URL = "https://api.umsoncloud.com/api";

const getFallbackBaseUrl = () => {
  return CLOUD_BASE_URL;
};

const configuredBaseUrl =
  process.env.REACT_APP_BASE_URL_PREFIX?.trim() ||
  (process.env.REACT_APP_BASE_URL?.trim()
    ? `${process.env.REACT_APP_BASE_URL.trim()}/api`
    : "");

axios.defaults.baseURL = normalize(configuredBaseUrl || getFallbackBaseUrl());

export default axios;
